<div class="file-upload-wrapper">

  <app-elem-drag-and-drop [files]="files_to_upload"></app-elem-drag-and-drop>

  @if (files_to_upload.length > 0) {
    <hr>
      <app-elem-file-list [files]="files_to_upload"></app-elem-file-list>
    }

  </div>